import React from 'react'
import VirtualCardsAllCards from 'src/app/VirtualCardsAllCards/VirtualCardsAllCards'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { virtualCardsAllCardsRouteProps } from 'src/navigation/routeProps'

const VirtualCardsAllCardsAppRoute: AppRoute = {
  id: AppLocation.VirtualCardsAll,
  routeProps: virtualCardsAllCardsRouteProps,
  component: <VirtualCardsAllCards />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default VirtualCardsAllCardsAppRoute
